import { useSEO } from "../hooks/useSEO";
import { useState, useEffect } from "react";
import { GOLD, NAVY, WHITE, CREAM, CORAL, TEAL, VIOLET, ALTIN_KOYU, DISPLAY, GOVDE, ALTIN_PARLAK, BLOK } from "../data/constants";
import { useMobile } from "../hooks/useMobile";

// ─── HERO ─────────────────────────────────────────────────────────────────────
function AboutHero() {
  const isMobile = useMobile();
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  return (
    <section style={{ background: BLOK, paddingTop: isMobile ? 110 : 140, paddingBottom: isMobile ? 72 : 110, paddingLeft: isMobile ? "6%" : "5%", paddingRight: isMobile ? "6%" : "5%", position: "relative", overflow: "hidden", boxSizing: "border-box" }}>
      {/* Dekorasyon */}
      <div style={{ position: "absolute", right: "-8%", top: "-10%", width: 500, height: 500, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.12)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", right: "-3%", top: "5%", width: 320, height: 320, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.08)", pointerEvents: "none" }} />
      <div style={{ position: "absolute", left: 0, top: "60%", width: "35%", height: 1, background: `linear-gradient(90deg, ${GOLD}30, transparent)`, pointerEvents: "none" }} />

      <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 2 }}>
        <div style={{
          display: "inline-flex", alignItems: "center", gap: 8,
          background: "rgba(168,121,42,0.12)", border: "1px solid rgba(168,121,42,0.3)",
          borderRadius: 4, padding: "6px 14px", marginBottom: 28,
          opacity: visible ? 1 : 0, transform: visible ? "translateY(0)" : "translateY(16px)",
          transition: "all 0.6s ease 0.1s",
        }}>
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: GOLD, display: "inline-block" }} />
          <span style={{ color: ALTIN_PARLAK, fontFamily: GOVDE, fontSize: 10, fontWeight: 700, letterSpacing: 2 }}>HAKKIMIZDA</span>
        </div>

        <h1 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(32px, 9vw, 52px)" : "clamp(40px, 5.5vw, 72px)", color: WHITE, fontWeight: 700, lineHeight: 1.1, margin: "0 0 10px", opacity: visible ? 1 : 0, transition: "all 0.7s ease 0.2s" }}>
          <span style={{ color: ALTIN_PARLAK }}>Reklamcılığı</span>
        </h1>
        <h1 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(32px, 9vw, 52px)" : "clamp(40px, 5.5vw, 72px)", fontWeight: 700, lineHeight: 1.1, margin: "0 0 28px", opacity: visible ? 1 : 0, transition: "all 0.7s ease 0.3s", color: ALTIN_PARLAK }}>
          Yeniden Tanımlıyoruz.
        </h1>
        <p style={{ fontFamily: GOVDE, fontSize: isMobile ? 15 : 17, color: "rgba(255,255,255,0.6)", lineHeight: 1.8, maxWidth: 560, margin: 0, opacity: visible ? 1 : 0, transition: "all 0.7s ease 0.4s" }}>
          <span style={{ color: ALTIN_PARLAK }}>Amerikan reklamcılık disipliniyle</span> Türk pazarını buluşturan, A'dan Z'ye tam hizmet sunan ilk ajans.
        </p>
      </div>

      <div style={{ position: "absolute", bottom: 0, left: 0, right: 0 }}>
        <svg viewBox="0 0 1440 50" fill="none" style={{ display: "block", width: "100%" }}>
          <path d="M0 50 L0 25 Q360 0 720 25 Q1080 50 1440 25 L1440 50 Z" fill={WHITE} />
        </svg>
      </div>
    </section>
  );
}

// ─── HİKAYE ───────────────────────────────────────────────────────────────────
function Story() {
  const isMobile = useMobile();
  return (
    <section style={{ background: WHITE, padding: isMobile ? "72px 6%" : "100px 5%", boxSizing: "border-box" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 48 : 80, alignItems: "center" }}>

          {/* Sol: metin */}
          <div>
            <div style={{ display: "inline-block", background: "rgba(168,121,42,0.1)", border: "1px solid rgba(168,121,42,0.25)", borderRadius: 4, padding: "5px 12px", marginBottom: 20 }}>
              <span style={{ color: ALTIN_KOYU, fontSize: 11, fontWeight: 700, letterSpacing: 2, fontFamily: GOVDE }}>HİKAYEMİZ</span>
            </div>
            <h2 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(26px, 7vw, 38px)" : "clamp(28px, 3.5vw, 44px)", color: NAVY, fontWeight: 700, lineHeight: 1.2, margin: "0 0 24px" }}>
              Bir <span style={{ color: CORAL }}>Sorudan</span><br /><span style={{ color: ALTIN_KOYU }}>Doğdu.</span>
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {[
                { text: <>Türkiye'de onlarca ajansla çalışan firmalar neden hâlâ doğru sonucu alamıyordu? Cevap basitti: her ajans sadece <span style={{ color: CORAL, fontWeight: 600 }}>kendi alanına</span> bakıyor, büyük resmi kimse görmüyordu.</> },
                { text: <>Whayns bu boşluğu doldurmak için kuruldu. <span style={{ color: TEAL, fontWeight: 600 }}>Strateji, prodüksiyon, dijital, geleneksel, yazılım</span>: hepsini tek çatı altında toplayan, Amerikan reklamcılık anlayışını Türkiye pazarına taşıyan bir ajans.</> },
                { text: <>Bugün <span style={{ color: VIOLET, fontWeight: 600 }}>9 farklı hizmet alanında</span>, tek bir ekip olarak çalışıyoruz. Tek muhatap biziz: ayrı ajanslarla koordinasyon derdi, bilgi kopukluğu, zaman kaybı yok.</> },
              ].map((item, i) => (
                <p key={i} style={{ fontFamily: GOVDE, fontSize: 15, color: "#3E3E38", lineHeight: 1.8, margin: 0 }}>{item.text}</p>
              ))}
            </div>
          </div>

          {/* Sağ: görsel kart */}
          <div style={{ position: "relative" }}>
            {/* Arka dekor */}
            <div style={{ position: "absolute", top: -16, right: -16, width: "100%", height: "100%", background: `rgba(168,121,42,0.08)`, borderRadius: 20, zIndex: 0 }} />
            <div style={{ position: "relative", zIndex: 1, background: BLOK, borderRadius: 20, padding: isMobile ? "36px 28px" : "48px 44px", overflow: "hidden" }}>
              <div style={{ position: "absolute", right: -40, bottom: -40, width: 200, height: 200, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.1)" }} />
              <div style={{ fontFamily: DISPLAY, fontSize: isMobile ? 48 : 64, fontWeight: 900, color: ALTIN_PARLAK, lineHeight: 1, marginBottom: 8 }}>2020</div>
              <div style={{ fontFamily: GOVDE, fontSize: 13, color: "rgba(255,255,255,0.5)", letterSpacing: 1, marginBottom: 36, textTransform: "uppercase" }}>Kuruluş Yılı</div>
              <div style={{ height: 1, background: "rgba(168,121,42,0.2)", marginBottom: 32 }} />
              {[
                { num: "9+", label: "Hizmet Alanı" },
                { num: "360°", label: "Tam Kapsam Yaklaşımı" },
                { num: "Global", label: "Yurt Dışı Pazar Erişimi" },
              ].map(({ num, label }, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "14px 0", borderBottom: i < 2 ? "1px solid rgba(255,255,255,0.06)" : "none" }}>
                  <span style={{ fontFamily: GOVDE, fontSize: 13, color: "rgba(255,255,255,0.5)" }}>{label}</span>
                  <span style={{ fontFamily: DISPLAY, fontSize: 22, color: ALTIN_PARLAK, fontWeight: 700 }}>{num}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── DEĞERLER ─────────────────────────────────────────────────────────────────
function Values() {
  const isMobile = useMobile();
  const values = [
    { icon: "", title: "Sonuç Odaklılık", desc: "\"Elimizden geleni yaptık\" demiyoruz. Her kampanyada neyin işe yarayıp neyin yaramadığını veriye bakarak söylüyoruz.", accent: ALTIN_KOYU },
    { icon: "", title: "Araştırma Önce Gelir", desc: "Strateji olmadan reklam, kör atıştan farksızdır. Her işe pazar analizi, rakip analizi ve hedef kitle araştırmasıyla başlıyoruz.", accent: ALTIN_KOYU },
    { icon: "", title: "Gerçek Ortaklık", desc: "Müşterilerimizi sadece fatura kesen bir tedarikçi olarak görmüyoruz. Başarılarını kendi başarımız sayıyoruz.", accent: ALTIN_KOYU },
    { icon: "", title: "Sınır Tanımayan Vizyon", desc: "Türkiye'den global pazarlara. Yurt dışı bağlantılarımız ve çok dilli pazarlama altyapımızla büyümende sınır koymuyoruz.", accent: ALTIN_KOYU },
    { icon: "⚡", title: "Hız ve Çeviklik", desc: "Bürokratik süreçler yok. Kararlar hızlı alınır, kampanyalar çabuk hayata geçer, sonuçlar anında raporlanır.", accent: ALTIN_KOYU },
    { icon: "", title: "Yaratıcılık + Disiplin", desc: "İyi bir fikir yetmez: doğru zamanda, doğru kanalda, doğru mesajla sunulması gerekir. Yaratıcılığımızı veriyle disipline ediyoruz.", accent: ALTIN_KOYU },
  ];

  return (
    <section style={{ background: CREAM, padding: isMobile ? "72px 6%" : "100px 5%", boxSizing: "border-box" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 40 : 64 }}>
          <div style={{ display: "inline-block", background: "rgba(168,121,42,0.1)", border: "1px solid rgba(168,121,42,0.25)", borderRadius: 4, padding: "5px 12px", marginBottom: 16 }}>
            <span style={{ color: ALTIN_KOYU, fontSize: 11, fontWeight: 700, letterSpacing: 2, fontFamily: GOVDE }}>DEĞERLERİMİZ</span>
          </div>
          <h2 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(26px, 7vw, 38px)" : "clamp(28px, 3.5vw, 44px)", color: NAVY, fontWeight: 700, margin: 0 }}>
            Neye İnanıyoruz, <span style={{ color: ALTIN_KOYU }}>Nasıl Çalışıyoruz</span>
          </h2>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)", gap: 20 }}>
          {values.map((v, i) => (
            <div key={i} style={{ background: WHITE, borderRadius: 16, padding: isMobile ? "24px 22px" : "32px 28px", border: "1px solid rgba(18,18,15,0.06)", borderTop: `3px solid ${v.accent || GOLD}` }}>
              <div style={{ fontSize: 28, marginBottom: 14 }}>{v.icon}</div>
              <div style={{ width: 32, height: 3, background: v.accent || GOLD, borderRadius: 2, marginBottom: 12 }} />
              <h3 style={{ fontFamily: DISPLAY, fontSize: 17, color: v.accent || NAVY, fontWeight: 700, margin: "0 0 10px" }}>{v.title}</h3>
              <p style={{ fontFamily: GOVDE, fontSize: 14, color: "#3E3E38", lineHeight: 1.75, margin: 0 }}>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── EKİP YAKLAŞIMI ───────────────────────────────────────────────────────────
function Approach() {
  const isMobile = useMobile();
  const pillars = [
    { num: "01", title: "Strateji", desc: "Her şey doğru soruyu sormakla başlar. Markan nerede, nereye gitmeli, nasıl?", accent: ALTIN_PARLAK },
    { num: "02", title: "Yaratıcı", desc: "Strateji kağıtta kalmasın. Görsel, metin, video: her şey hikayeyi anlatacak şekilde.", accent: ALTIN_PARLAK },
    { num: "03", title: "Teknoloji", desc: "Web sitesinden e-ticaret altyapısına, reklam otomasyonundan CRM entegrasyonuna.", accent: ALTIN_PARLAK },
    { num: "04", title: "Analiz", desc: "Ne işe yaradı, ne yaramadı? Veriye bakarak karar alıyoruz, tahmin değil.", accent: ALTIN_PARLAK },
  ];

  return (
    <section style={{ background: BLOK, padding: isMobile ? "72px 6%" : "100px 5%", boxSizing: "border-box", position: "relative", overflow: "hidden" }}>
      <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-50%)", width: 700, height: 700, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.05)", pointerEvents: "none" }} />
      <div style={{ maxWidth: 1200, margin: "0 auto", position: "relative", zIndex: 2 }}>
        <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", gap: isMobile ? 40 : 80, alignItems: "center" }}>
          <div>
            <div style={{ display: "inline-block", background: "rgba(168,121,42,0.1)", border: "1px solid rgba(168,121,42,0.25)", borderRadius: 4, padding: "5px 12px", marginBottom: 20 }}>
              <span style={{ color: ALTIN_PARLAK, fontSize: 11, fontWeight: 700, letterSpacing: 2, fontFamily: GOVDE }}>YAKLAŞIMIMIZ</span>
            </div>
            <h2 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(26px, 7vw, 38px)" : "clamp(28px, 3.5vw, 44px)", color: WHITE, fontWeight: 700, lineHeight: 1.2, margin: "0 0 20px" }}>
              Dört Sütun,<br /><span style={{ color: ALTIN_PARLAK }}>Tek Ekip.</span>
            </h2>
            <p style={{ fontFamily: GOVDE, fontSize: 15, color: "rgba(255,255,255,0.55)", lineHeight: 1.8, margin: "0 0 32px" }}>
              Çoğu ajans bu dört alanı dört farklı firmayla çözmeye çalışır. Biz hepsini tek ekip olarak yönetiyoruz: koordinasyon kayıpları yok, mesaj tutarsızlıkları yok.
            </p>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              {["Strateji", "Kreatif", "Dijital", "Prodüksiyon", "Yazılım"].map((tag, i) => (
                <span key={i} style={{ fontFamily: GOVDE, fontSize: 11, fontWeight: 600, padding: "5px 14px", borderRadius: 4, background: "rgba(168,121,42,0.1)", color: ALTIN_PARLAK, border: "1px solid rgba(168,121,42,0.2)" }}>{tag}</span>
              ))}
            </div>
          </div>

          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {pillars.map((p, i) => (
              <div key={i} style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.06)", borderLeft: `3px solid ${p.accent || GOLD}`, borderRadius: 12, padding: "20px 24px", display: "flex", gap: 16, alignItems: "flex-start" }}>
                <span style={{ fontFamily: DISPLAY, fontSize: 13, color: p.accent || GOLD, fontWeight: 700, flexShrink: 0, marginTop: 2 }}>{p.num}</span>
                <div>
                  <h3 style={{ fontFamily: DISPLAY, fontSize: 16, color: p.accent || GOLD, fontWeight: 700, margin: "0 0 6px" }}>{p.title}</h3>
                  <p style={{ fontFamily: GOVDE, fontSize: 13, color: "rgba(255,255,255,0.5)", lineHeight: 1.7, margin: 0 }}>{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── FARK ─────────────────────────────────────────────────────────────────────
function WhyUs() {
  const isMobile = useMobile();
  const rows = [
    { topic: "Hizmet kapsamı", others: "Tek alan (sadece dijital veya sadece prodüksiyon)", whayns: "9 alanda tam kapsam, tek çatı altında" },
    { topic: "Muhatap sayısı", others: "Her hizmet için ayrı ajans, ayrı toplantı, ayrı fatura", whayns: "Tek ekip, tek sorumlu, tek muhatap" },
    { topic: "Süreç başlangıcı", others: "Hemen reklam kurulumu: analiz yok", whayns: "Önce araştırma, sonra strateji, sonra üretim" },
    { topic: "Raporlama", others: "\"Yaptık\": detay yok", whayns: "Haftalık/aylık şeffaf veri raporları" },
    { topic: "Yurt dışı", others: "Genellikle sadece Türkiye odaklı", whayns: "Global pazar bağlantısı ve ihracat desteği" },
  ];

  return (
    <section style={{ background: WHITE, padding: isMobile ? "72px 6%" : "100px 5%", boxSizing: "border-box" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: isMobile ? 36 : 56 }}>
          <div style={{ display: "inline-block", background: "rgba(168,121,42,0.1)", border: "1px solid rgba(168,121,42,0.25)", borderRadius: 4, padding: "5px 12px", marginBottom: 16 }}>
            <span style={{ color: ALTIN_KOYU, fontSize: 11, fontWeight: 700, letterSpacing: 2, fontFamily: GOVDE }}>KARŞILAŞTIRMA</span>
          </div>
          <h2 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(24px, 7vw, 36px)" : "clamp(26px, 3.5vw, 42px)", color: NAVY, fontWeight: 700, margin: 0 }}>
            <span style={{ color: CORAL }}>Diğerleri</span> vs. <span style={{ color: TEAL }}>Whayns</span>
          </h2>
        </div>

        {/* Tablo */}
        <div style={{ borderRadius: 16, overflow: "hidden", border: "1px solid rgba(18,18,15,0.08)" }}>
          {/* Header */}
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "1.2fr 2fr 2fr", background: BLOK }}>
            {!isMobile && <div style={{ padding: "16px 24px", fontFamily: GOVDE, fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.4)", letterSpacing: 1.5, textTransform: "uppercase" }}>Konu</div>}
            <div style={{ padding: "16px 24px", fontFamily: GOVDE, fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.4)", letterSpacing: 1.5, textTransform: "uppercase" }}>Diğer Ajanslar</div>
            <div style={{ padding: "16px 24px", fontFamily: GOVDE, fontSize: 11, fontWeight: 700, color: ALTIN_PARLAK, letterSpacing: 1.5, textTransform: "uppercase" }}>Whayns ✓</div>
          </div>

          {rows.map((row, i) => (
            <div key={i} style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr 1fr" : "1.2fr 2fr 2fr", background: i % 2 === 0 ? WHITE : CREAM, borderTop: "1px solid rgba(18,18,15,0.06)" }}>
              {!isMobile && <div style={{ padding: "18px 24px", fontFamily: GOVDE, fontSize: 13, fontWeight: 700, color: NAVY }}>{row.topic}</div>}
              <div style={{ padding: "18px 24px", fontFamily: GOVDE, fontSize: 13, color: "#3E3E38", lineHeight: 1.6 }}>{row.others}</div>
              <div style={{ padding: "18px 24px", fontFamily: GOVDE, fontSize: 13, color: NAVY, fontWeight: 600, lineHeight: 1.6, borderLeft: `2px solid ${GOLD}` }}>{row.whayns}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

// ─── CTA ──────────────────────────────────────────────────────────────────────
function AboutCTA({ onNavigate }) {
  const isMobile = useMobile();
  return (
    <section style={{ background: CREAM, padding: isMobile ? "72px 6%" : "100px 5%", boxSizing: "border-box" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ background: BLOK, borderRadius: 24, padding: isMobile ? "48px 28px" : "72px 80px", position: "relative", overflow: "hidden", textAlign: "center" }}>
          <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-50%)", width: 600, height: 600, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.06)", pointerEvents: "none" }} />
          <div style={{ position: "absolute", left: "50%", top: "50%", transform: "translate(-50%,-50%)", width: 400, height: 400, borderRadius: "50%", border: "1px solid rgba(168,121,42,0.08)", pointerEvents: "none" }} />
          <div style={{ position: "relative", zIndex: 2 }}>
            <div style={{ fontSize: 40, marginBottom: 20 }}></div>
            <h2 style={{ fontFamily: DISPLAY, fontSize: isMobile ? "clamp(26px, 7vw, 38px)" : "clamp(28px, 3.5vw, 48px)", color: WHITE, fontWeight: 700, margin: "0 0 16px", lineHeight: 1.2 }}>
              Birlikte <span style={{ color: ALTIN_PARLAK }}>çalışalım</span>.
            </h2>
            <p style={{ fontFamily: GOVDE, fontSize: isMobile ? 14 : 16, color: "rgba(255,255,255,0.55)", lineHeight: 1.8, maxWidth: 500, margin: "0 auto 36px" }}>
              Markan için doğru stratejiyi birlikte belirleyelim. İlk görüşme ücretsiz, bağlayıcı değil.
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap", flexDirection: isMobile ? "column" : "row", alignItems: "center" }}>
              <button
                onClick={() => onNavigate("contact")}
                style={{ background: GOLD, color: NAVY, padding: "16px 44px", borderRadius: 8, border: "none", fontFamily: GOVDE, fontSize: 15, fontWeight: 700, letterSpacing: 0.5, cursor: "pointer", width: isMobile ? "100%" : "auto" }}
              >Ücretsiz Analiz Al →</button>
              <button
                onClick={() => onNavigate("services")}
                style={{ background: "transparent", color: WHITE, padding: "16px 44px", borderRadius: 8, border: "1px solid rgba(255,255,255,0.2)", fontFamily: GOVDE, fontSize: 15, fontWeight: 500, cursor: "pointer", width: isMobile ? "100%" : "auto" }}
              >Hizmetlere Bak</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── ANA EXPORT ───────────────────────────────────────────────────────────────
export default function AboutPage({ onNavigate }) {
  useSEO({ title: "Hakkımızda: Reklamcılığı Yeniden Tanımlıyoruz", description: "2020 yılında kurulan Whayns Dijital, Amerikan reklamcılık anlayışını Türkiye pazarına taşıyan tam kapsamlı reklam ajansı. 9 hizmet alanında tek çatı altında.", path: "/hakkimizda" });
  return (
    <div style={{ overflowX: "hidden", width: "100%" }}>
      <AboutHero />
      <Story />
      <Values />
      <Approach />
      <WhyUs />
      <AboutCTA onNavigate={onNavigate} />
    </div>
  );
}